import React from "react";
import { Box, Typography } from "@mui/material";
import { ReactComponent as SquareLeft } from "../../assets/square-left.svg";
import { ReactComponent as SquareRight } from "../../assets/square-right.svg";
import { ReactComponent as CsvDownloadButton } from "../../assets/csv-download-button.svg";
import { useExportPage } from "./useExportPage";
import { ExportFormatSelect } from "./components/ExportFormatSelect";
import { ExportFilterBar } from "./components/ExportFilterBar";
import { ExportTable } from "./components/ExportTable";

const ExportPage: React.FC = () => {
  const {
    format,
    setFormat,
    results,
    columnDefs,
    propertyFilter, setPropertyFilter,
    roomFilter, setRoomFilter,
    lesseeFilter, setLesseeFilter,
    propertyOptions,
    roomOptions,
    lesseeOptions,
    loading,
    contextError,
    handleSearch,
    handleClearSearch,
    mode,
    dataMode,
    itandiLoading,
    selectedIds,
    selectAllMode,
    anchorEl,
    numSelected,
    handleSelectRow,
    handleSelectAllClick,
    handleMenuClick,
    handleMenuClose,
    handleSelectAllMenuItems,
    handleSelectPageMenuItems,
    handleDeselectAll,
    page,
    rowsPerPage,
    currentVisibleRows,
    totalCount,
    rowCount,
    handleChangePage,
    handleChangeRowsPerPage,
    sortOrder,
    setSortOrder,
    isDownloading,
    clientError,
    handleDownload,
  } = useExportPage();

  return (
    <Box
      sx={{
        p: 3,
        backgroundColor: "#ECEBF0",
        borderRadius: "16px",
        boxShadow: `4px 4px 6px 0 rgba(26, 26, 26, 0.25),
                      -10px -10px 6px 0 rgba(255, 255, 255, 0.95)`,
        backdropFilter: "blur(4px)",
        border: "1px solid rgba(31, 31, 31, 0.05)",
        width: "95%",
        maxWidth: "1000px",
        display: "flex",
        flexDirection: "column",
        mt: "2rem",
        ml: "0%",
        mb: "2rem",
        position: "relative",
        overflowY: "auto",
        overflowX: "auto",
        maxHeight: "calc(100vh - 10rem)",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontSize: "200%",
          fontWeight: "bold",
          color: "rgb(50, 225, 170)",
          ml: 2,
          mt: 2,
          mb: 0,
        }}
      >
        出力画面
      </Typography>

      <ExportFormatSelect format={format} onFormatChange={setFormat} />

      <ExportFilterBar
        format={format}
        propertyFilter={propertyFilter}
        roomFilter={roomFilter}
        lesseeFilter={lesseeFilter}
        propertyOptions={propertyOptions}
        roomOptions={roomOptions}
        lesseeOptions={lesseeOptions}
        onPropertyChange={setPropertyFilter}
        onRoomChange={setRoomFilter}
        onLesseeChange={setLesseeFilter}
        onSearch={handleSearch}
        onClearSearch={handleClearSearch}
        loading={loading}
        mode={mode}
        dataMode={dataMode}
      />

      <ExportTable
        format={format}
        columnDefs={columnDefs}
        results={results}
        currentVisibleRows={currentVisibleRows}
        loading={loading}
        contextError={contextError}
        clientError={clientError}
        selectedIds={selectedIds}
        selectAllMode={selectAllMode}
        totalCount={totalCount}
        numSelected={numSelected}
        rowCount={rowCount}
        anchorEl={anchorEl}
        page={page}
        rowsPerPage={rowsPerPage}
        sortOrder={sortOrder}
        dataMode={dataMode}
        itandiLoading={itandiLoading}
        onSelectRow={handleSelectRow}
        onSelectAllClick={handleSelectAllClick}
        onMenuClick={handleMenuClick}
        onMenuClose={handleMenuClose}
        onSelectAllMenuItems={handleSelectAllMenuItems}
        onSelectPageMenuItems={handleSelectPageMenuItems}
        onDeselectAll={handleDeselectAll}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        onSortChange={(newOrder) => { setSortOrder(newOrder); }}
      />

      {/* CSVダウンロードボタン */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: -4, mb: -4 }}>
        <Box
          onClick={(!selectAllMode && selectedIds.size === 0) || isDownloading ? undefined : handleDownload}
          sx={{
            cursor: (!selectAllMode && selectedIds.size === 0) || isDownloading ? "not-allowed" : "pointer",
            opacity: (!selectAllMode && selectedIds.size === 0) || isDownloading ? 0.3 : 1,
            transition: "opacity 0.2s ease-in-out",
            "&:hover": {
              opacity: (!selectAllMode && selectedIds.size === 0) || isDownloading ? 0.3 : 0.8,
            },
            "&:active": {
              opacity: (!selectAllMode && selectedIds.size === 0) || isDownloading ? 0.2 : 0.7,
              transform: "scale(0.98)",
            },
          }}
        >
          <CsvDownloadButton style={{ width: "450px", height: "auto", maxWidth: "95%" }} />
        </Box>
      </Box>

      <Box sx={{ display: "flex", pointerEvents: "none" }}>
        <Box sx={{ width: "9%", pointerEvents: "auto" }}>
          <SquareLeft />
        </Box>
        <Box sx={{ width: "9%", pointerEvents: "auto", marginLeft: "auto" }}>
          <SquareRight />
        </Box>
      </Box>
    </Box>
  );
};

export default ExportPage;
